<style>
</style>

<script>
	import iconv from "iconv-lite";
	import Base64 from "crypto-js/enc-base64";
	import Utf8 from "crypto-js/enc-utf8";

	export default {
		name: "TextEncodeDecode",
		data: function () {
			return {
				contentSource: "",
				contentDestination: "",
				types: [
					{
						name: "Common",
						values: ["URL", "BASE64"]
					},
					{
						name: "Unicode",
						values: ["UTF-8", "UCS-2", "UCS-4", "UCS-4BE", "UCS-4LE", "UTF-16", "UTF-16BE", "UTF-16LE", "UTF-32", "UTF-32BE", "UTF-32LE", "UTF-7"]
					},
					{
						name: "Chinese",
						values: ["EUC-CN", "GBK", "CP936", "GB18030", "BIG5", "CP950", "BIG5-HKSCS", "BIG5-HKSCS:2004", "BIG5-HKSCS:2001", "BIG5-HKSCS:1999"]
					},
					{
						name: "Japanese",
						values: ["EUC-JP", "SHIFT_JIS", "CP932"]
					},
					{
						name: "Korean",
						values: ["EUC-KR", "CP949"]
					}
				]
			};
		},
		methods: {
			encode: function (event) {
				const encType = this.$refs.encType.value;
				switch (encType) {
					case "URL": {
						this.contentDestination = encodeURIComponent(this.contentSource);
						break;
					}
					case "BASE64": {
						this.contentDestination = Base64.stringify(Utf8.parse(this.contentSource));
						break;
					}
					default: {
						this.contentDestination = iconv.encode(this.contentSource, encType);
						break;
					}
				}
			},
			decode: function (event) {
				const encType = this.$refs.encType.value;
				switch (encType) {
					case "URL": {
						this.contentSource = decodeURIComponent(this.contentDestination);
						break;
					}
					case "BASE64": {
						this.contentSource = Utf8.stringify(Base64.parse(this.contentDestination));
						break;
					}
					default: {
						this.contentSource = iconv.decode(this.contentDestination, encType);
						break;
					}
				}
			},
			swap: function (event) {
				const temp = this.contentDestination;
				this.contentDestination = this.contentSource;
				this.contentSource = temp;
			}
		}
	}
</script>

<template>
	<div>
		<div class="content-top">
			<h4>Text Encode/Decode</h4>
			<small>Text Encode/Decode Description.</small>
		</div>
		<div class="content-center">
			<div class="row">
				<div class="col-12 mt-3">
					Source
				</div>
				<div class="col-12">
					<textarea class="form-control" rows="8" v-model="contentSource"/>
<!--					<img src="@/assets/logo.png"/>-->
				</div>
			</div>
			<div class="row">
				<div class="col-12 mt-3 mb-3 text-center form-inline justify-content-center">
					<select class="form-control mr-1 form-control-sm mt-1" ref="encType">
						<optgroup v-for="type in types" :key="type.name" :label="type.name">
							<option v-for="value in type.values" :key="value" :value="value">{{value}}</option>
						</optgroup>
					</select>
					<button type="button" class="btn btn-secondary mt-1 mr-1 btn-sm" v-on:click="encode($event)">
						<font-awesome-icon icon="long-arrow-alt-down" class="mr-2"/>
						Encode
					</button>
					<button type="button" class="btn btn-secondary mt-1 mr-1 btn-sm" v-on:click="decode($event)">
						<font-awesome-icon icon="long-arrow-alt-up" class="mr-2"/>
						Decode
					</button>
					<button type="button" class="btn btn-secondary btn-sm mt-1" v-on:click="swap($event)">
						<font-awesome-icon icon="arrows-alt-v" class="mr-2"/>
						Swap
					</button>
				</div>
			</div>
			<div class="row">
				<div class="col-12">
					Destination
				</div>
				<div class="col-12">
					<textarea class="form-control" rows="8" v-model="contentDestination"/>
				</div>
			</div>
		</div>
		<div class="content-bottom">
		</div>
	</div>
</template>
